import { render } from "./ResourceTableToolbarNew.vue?vue&type=template&id=cc1b1038"
import script from "./ResourceTableToolbarNew.vue?vue&type=script&lang=js"
export * from "./ResourceTableToolbarNew.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ResourceTableToolbarNew.vue"]])

export default __exports__